export const STATE = "stateCode";
export const LICENSE_CATEGORY = "licenseCategory";
export const AUDIT_SCOPE = "auditScope";
export const EFFECTIVE_DATE = "effectiveDate";
export const DESCRIPTION = "description";
export const INCLUDE_STATE_LAW = "isIncludeStateLaw"
export const CONTENT = "contentRichText";
export const TEMPLATE_NAME = "templateName";
export const VERSION_NO = "versionNo";
export const STATUS = "status";

export const licenseCategoryOptions = [
  { label: "Bi-Party", value: "BI_PARTY" },
  { label: "Tri-Party", value: "TRI_PARTY" },
];

export const auditScopeOptions = [
  { label: "State", value: "STATE" },
  { label: "Federal", value: "FEDERAL" },
];